import Subsidies from './Subsidies'


export default Subsidies
